<template>

    <trax-ui-ajax-form-in-modal :id="id" :endpoint="endpoint" class="trax-no-required"
        :props="props" :titles="titles" :bus="bus" :form="form" :action="action" icons="1">

        <p>{{ confirmText }}</p>

        <trax-ui-input type="password" icon="lock" :placeholder="lang.polaris.account.password"
            v-model="form.password" v-bind:error="errors.password" required="1">
        </trax-ui-input>

    </trax-ui-ajax-form-in-modal>
    
</template>

<script>
    export default {

        props: {
            id: null,
            simpleText: null,
            text: {default: lang.polaris.dashboard.save_and_sign_confirm_text},
            bus: null,
        },
    
        data: function() {
            var actionLabel = this.simpleText ? lang.polaris.dashboard.sign : lang.polaris.dashboard.save_and_sign;
            return {
                lang: lang,
                endpoint: app_url+'polaris/api/front/users/passcheck',
                form: {},
                errors: {},
                action: {
                    label: actionLabel
                },
                props: {
                    password: { source:'password' },
                },
                titles: {
                    new: lang.polaris.dashboard.signature
                }
            }
        },

        computed: {

            confirmText: function() {
                return this.simpleText ? this.lang.polaris.dashboard.save_and_sign_confirm_simple_text : this.text;
            }

        },

        created: function() {
            var that = this;

            this.bus.$on(that.id+'-errors', function(errors) {
                that.errors = errors;
            });

            this.bus.$on(that.id+'-data', function(data) {
                that.form = data;
            });
        }

    }
</script>
